import { TweenMax } from "gsap";
import App from "../App";

export default class BangUp {

    public currentBangup: {val: number, endVal: number};
    private updateFunction: (params?: any) => void;
    private onCompleteFunction: () => void;

    public startBangup(startVal: number, endVal: number, duration, options: any, onUpdateFunction: (param: any) => void, onCompleteFunction?: () => any) {
        if (!options) {
            options = {};
        }
        this.clearBangup();
        this.currentBangup = {val: startVal, endVal};
        this.updateFunction = onUpdateFunction;
        this.onCompleteFunction = onCompleteFunction;
        options.onUpdate = this.updateFunction = onUpdateFunction;
        options.val = endVal;
        options.onUpdate = () => {onUpdateFunction(this.currentBangup.val)};
        options.onComplete = () => {this.clearBangup()};
        App.timeline.add(TweenMax.to(this.currentBangup, duration, options), App.timeline.time());
    }

    public clearBangup() {
        if (this.currentBangup) {
            if (this.updateFunction) {
                this.updateFunction(this.currentBangup.endVal);
            }

            TweenMax.killTweensOf(this.currentBangup);
            this.currentBangup = null;
            this.updateFunction = null;
            if (this.onCompleteFunction) {
                this.onCompleteFunction();
            }
            this.onCompleteFunction = null;
        }
    }
}